// Copyright 2025, University of Maryland, All Rights Reserved
import { memo } from 'react'
import { Highlighter } from 'lucide-react'

import { BaseNode } from '@/subsystems/pipelines'

export const RedlineWorkflowNode = memo(() => (
  <BaseNode
    icon={<Highlighter />}
    label="Redline"
    hasInput
    hasOutput
  />
))

RedlineWorkflowNode.displayName = 'RedlineWorkflowNode'
